<template>
    <div class="axios chartConfig_viewDP">
        <div class="chartDivConfig numViewConfig numViewConfig_unit" >
            <span class="span_til">极坐标半径</span>
            <el-input v-model="config.polar.radius" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">%</div>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.angleAxis.show" @change="getRender">是否显示极坐标角度轴</el-checkbox>
        </div>
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">角度轴最小值</span>
            <el-input v-model="config.angleAxis.min" @change="getRender" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">角度轴最大值</span>
            <el-input v-model="config.angleAxis.max" @change="getRender" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">轴线颜色</span>
            <el-color-picker v-model="config.angleAxis.axisLine.lineStyle.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.angleAxis.axisLabel.show" @change="getRender">是否显示文字</el-checkbox>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">字体颜色</span>
            <el-color-picker v-model="config.angleAxis.axisLabel.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">字体大小</span>
            <el-input v-model="config.angleAxis.axisLabel.fontSize" @change="getRender" type="number" min="12"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">字体角度</span>
            <el-input v-model="config.angleAxis.axisLabel.rotate" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">度</div>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.angleAxis.axisTick.show" @change="getRender">是否显示角度轴刻度</el-checkbox>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.angleAxis.splitLine.show" @change="getRender">是否显示分隔线</el-checkbox>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">分隔线颜色</span>
            <el-color-picker v-model="config.angleAxis.splitLine.lineStyle.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">分隔线宽度</span>
            <el-input v-model="config.angleAxis.splitLine.lineStyle.width" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">px</div>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/27 5:58 下午
     */
    export default {
        name: 'axios',
        components: {},
        props: {
            name: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                typeList:[
                    {value: 'category', label: '类目轴'},
                    {value: 'value', label: '数值轴'},
                ],
                lineList:[
                    {value: 'solid', label: '实线'},
                    {value: 'dashed', label: '虚线'},
                    {value: 'dotted', label: '点线'},
                ]
            }
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            },
            nowChart() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.nowChart;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart;
                }
            }
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .axios {
        .chartDivConfig {
            .span_til {
                width: 32%!important;
                max-width: 90px !important;
            }
        }
    }
</style>